/* Chocolate Counter — Build Your Own Box "see inside". CC V_1_0 (Oct 31, 2026).
   Jack, Oct 31: "can we make build your own page have the cut picture with a mouse over so people can see whats inside
   the chocolate ?" Each flavour's cut-open photo comes from the builder feed (templates/collection.builder-feed.liquid
   V_2_1) on the end of the tile photo's address as "#in=<address>". Browsers never send that part, so the main photo
   loads exactly as before and assets/cc-byob.js needs no change.
   • Mouse: the cut photo fades in while the pointer is over the flavour.
   • Touch screens and keyboards: the small round button on the photo's corner shows and hides it (tapping the photo
     itself still adds the flavour, as before).
   The cut photo is only fetched the first time it is wanted. Loaded from layout/theme.liquid on the home page (mini
   builder) and the Build Your Own Box page only.
   Also (same day, "not display sold out options"): sold-out sizes are no longer shown at all (feed V_2_1), so a greyed
   size button now only means "no room left in this box". It is faded instead of crossed out, so it doesn't read as
   sold out. */
(function () {
  if (window.__ccPeek) return;
  window.__ccPeek = true;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5"/></svg>';
  var css = [
    '.byob .sz:disabled{text-decoration:none}',
    '.byob .ph .badge{z-index:1}',
    '.byob .ph img.cc-in{position:absolute;top:8%;left:8%;width:84%;height:84%;object-fit:cover;border-radius:50%;opacity:0;pointer-events:none;transition:opacity .2s ease,transform .25s ease}',
    '.byob .tile.cc-peek-on .ph img.cc-in.ready{opacity:1}',
    '.byob .cc-peekbox{position:absolute;left:0;top:0;width:100%;aspect-ratio:1/1;pointer-events:none;z-index:3}',
    '.byob .cc-peek{position:absolute;right:8px;bottom:8px;width:34px;height:34px;padding:0;border:0;border-radius:50%;background:#fff;color:#272831;box-shadow:inset 0 0 0 1.5px #272831;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;pointer-events:auto}',
    '.byob .cc-peek svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round}',
    '.byob .cc-peek[aria-pressed="true"]{background:#272831;color:#fff}',
    '@media (hover:hover) and (pointer:fine){.byob .tile:hover .ph img.cc-in.ready{opacity:1}.byob .cc-peek{opacity:0;transition:opacity .15s ease}.byob .tile:hover .cc-peek,.byob .cc-peek:focus-visible{opacity:1}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function cutUrl(img) {
    var s = img.getAttribute('src') || '';
    var i = s.indexOf('#in=');
    return i < 0 ? '' : s.slice(i + 4);
  }
  function dress(tile) {
    if (tile.__ccPeek) return;
    var ph = tile.querySelector('.ph');
    var main = ph && ph.querySelector('img');
    if (!main) return;
    tile.__ccPeek = true;
    var url = cutUrl(main);
    if (!url) return;
    var cut = document.createElement('img');
    cut.className = 'cc-in';
    cut.alt = '';
    cut.decoding = 'async';
    cut.setAttribute('data-src', url);
    ph.appendChild(cut);
    var name = ((tile.querySelector('.name') || {}).textContent || '').trim();
    var box = document.createElement('div');
    box.className = 'cc-peekbox';
    box.innerHTML = '<button type="button" class="cc-peek" aria-pressed="false" title="See inside">' + ICON + '</button>';
    box.firstChild.setAttribute('aria-label', 'See inside ' + (name || 'this flavour'));
    ph.insertAdjacentElement('afterend', box);
  }
  function load(tile) {
    var cut = tile && tile.querySelector('img.cc-in[data-src]');
    if (!cut) return;
    cut.onload = function () { cut.classList.add('ready'); };
    cut.onerror = function () { var b = tile.querySelector('.cc-peekbox'); if (b) b.remove(); cut.remove(); };
    cut.src = cut.getAttribute('data-src');
    cut.removeAttribute('data-src');
  }
  function bind(root) {
    if (root.__ccPeek) return;
    root.__ccPeek = true;
    var scan = function () { root.querySelectorAll('.tile').forEach(dress); };
    scan();
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    root.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var t = e.target.closest && e.target.closest('.tile');
      if (t) load(t);
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cc-peek');
      if (!b) return;
      var t = b.closest('.tile');
      load(t);
      var on = !t.classList.contains('cc-peek-on');
      t.classList.toggle('cc-peek-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function boot() { document.querySelectorAll('.byob[data-byob]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
